import type { CustomCellRendererProps } from "ag-grid-react";

import { Button } from "@synthesis/shared-ui";
import { IconBin, IconDownload, IconExportUpload } from "@synthesis/shared-icons";

import type { TuPartRow, TuPartTableContext } from "./tu-parts.lib";

export const TuPartActionsCell = ({ data, context }: CustomCellRendererProps<TuPartRow, unknown, TuPartTableContext>) => {
  if (!data) {
    return null;
  }

  const hasFile = Boolean(data.fileId);

  return (
    <div className="flex items-center justify-center gap-1">
      {hasFile ? (
        <Button
          type="button"
          theme="text"
          size="sm"
          shape="square"
          aria-label="Скачать часть ТУ"
          onClick={() => context.onDownload(data)}
          icon={<IconDownload className="size-5" />}
        />
      ) : null}
      {context.canUpload ? (
        <Button
          type="button"
          theme="text"
          size="sm"
          shape="square"
          aria-label="Загрузить часть ТУ"
          onClick={() => context.onUpload(data)}
          icon={<IconExportUpload className="size-5" />}
        />
      ) : null}
      {hasFile && context.canDelete ? (
        <Button
          type="button"
          theme="text"
          size="sm"
          shape="square"
          aria-label="Удалить часть ТУ"
          onClick={() => context.onDelete(data)}
          icon={<IconBin className="size-5" />}
        />
      ) : null}
    </div>
  );
};
